import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { ERouterName } from '/@/types/index'
import CreatePlan from '/@/components/task/CreatePlan.vue'
import WaylinePanel from '/@/pages/page-web/projects/wayline.vue'
import DockPanel from '/@/pages/page-web/projects/dock.vue'
import LiveAgora from '/@/components/livestream-agora.vue'
import LiveOthers from '/@/components/livestream-others.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/' + ERouterName.PROJECT
  },
  // Home page
  {
    path: '/' + ERouterName.PROJECT,
    name: ERouterName.PROJECT,
    component: () => import('/@/pages/page-web/index.vue')
  },
  // members, devices
  {
    path: '/' + ERouterName.HOME,
    name: ERouterName.HOME,
    component: () => import('/@/pages/page-web/home.vue'),
    children: [
      {
        path: '/' + ERouterName.MEMBERS,
        name: ERouterName.MEMBERS,
        component: () => import('/@/pages/page-web/projects/members.vue')
      },
      {
        path: '/' + ERouterName.DEVICES,
        name: ERouterName.DEVICES,
        component: () => import('/@/pages/page-web/projects/devices.vue')
      },
      {
        path: '/' + ERouterName.FIRMWARES,
        name: ERouterName.FIRMWARES,
        component: () => import('../pages/page-web/projects/Firmwares.vue')
      }
    ]
  },
  // workspace
  {
    path: '/' + ERouterName.WORKSPACE,
    name: ERouterName.WORKSPACE,
    component: () => import('/@/pages/page-web/projects/workspace.vue'),
    redirect: '/' + ERouterName.TSA,
    children: [
      {
        path: '/' + ERouterName.TSA,
        component: () => import('/@/pages/page-web/projects/tsa.vue')
      },
      {
        path: '/' + ERouterName.LIVESTREAM,
        name: ERouterName.LIVESTREAM,
        component: () => import('/@/pages/page-web/projects/livestream.vue'),
        children: [
          {
            path: ERouterName.LIVING,
            name: ERouterName.LIVING,
            components: {
              LiveAgora,
              LiveOthers
            }
          }
        ]
      },
      {
        path: '/' + ERouterName.LAYER,
        name: ERouterName.LAYER,
        component: () => import('/@/pages/page-web/projects/layer.vue')
      },
      {
        path: '/' + ERouterName.WAYLINE,
        name: ERouterName.WAYLINE,
        component: () => import('/@/pages/page-web/projects/wayline.vue')
      },
      {
        path: '/' + ERouterName.TASK,
        name: ERouterName.TASK,
        component: () => import('/@/pages/page-web/projects/task.vue'),
        children: [
          {
            path: ERouterName.CREATE_PLAN,
            name: ERouterName.CREATE_PLAN,
            component: CreatePlan,
            children: [
              {
                path: ERouterName.SELECT_PLAN,
                name: ERouterName.SELECT_PLAN,
                components: {
                  WaylinePanel,
                  DockPanel
                }
              }
            ]
          }

        ]
      },
      {
        path: '/' + ERouterName.FLIGHT_AREA,
        name: ERouterName.FLIGHT_AREA,
        component: () => import('/@/pages/page-web/projects/flight-area.vue')
      },
      {
        path: '/' + ERouterName.OPERATORS,
        name: ERouterName.OPERATORS,
        component: () => import('/@/pages/page-web/projects/operators.vue')
      },
    ]
  },
  // AI test + izveštaji + snimci — full-screen (bez mape/workspace tabele u pozadini)
  {
    path: '/' + ERouterName.MEDIA,
    name: ERouterName.MEDIA,
    component: () => import('/@/pages/page-web/projects/media.vue')
  },
  {
    path: '/' + ERouterName.AI_TEST,
    name: ERouterName.AI_TEST,
    component: () => import('/@/pages/page-web/projects/ai-test.vue')
  },
  {
    path: '/' + ERouterName.REPORTS,
    name: ERouterName.REPORTS,
    component: () => import('/@/pages/page-web/projects/reports/index.vue')
  },
  // mission editor (full-screen, own satellite map)
  {
    path: '/' + ERouterName.MISSION_EDITOR,
    name: ERouterName.MISSION_EDITOR,
    component: () => import('/@/pages/page-web/mission-editor/index.vue')
  },
  // monitoring centar (full-screen ekran za operatere)
  {
    path: '/' + ERouterName.MONITORING,
    name: ERouterName.MONITORING,
    component: () => import('/@/pages/page-web/monitoring/index.vue')
  },
  // direktori: uživo + snimci + izveštaj letova (telefon i laptop)
  {
    path: '/' + ERouterName.DIREKTOR,
    name: ERouterName.DIREKTOR,
    component: () => import('/@/pages/page-web/direktor/index.vue')
  },
  // FlightHub-stil Virtual Cockpit (full-screen: video + telemetrija + komande)
  {
    path: '/' + ERouterName.COCKPIT,
    name: ERouterName.COCKPIT,
    component: () => import('/@/pages/page-web/cockpit/index.vue')
  },
  // WebRTC/WHIP test (merenje kašnjenja)
  {
    path: '/' + ERouterName.RTC_TEST,
    name: ERouterName.RTC_TEST,
    component: () => import('/@/pages/page-web/rtc-test/index.vue')
  },
  // mobilni komandni centar (PWA, /m)
  {
    path: '/' + ERouterName.MOBILE,
    name: ERouterName.MOBILE,
    component: () => import('/@/pages/page-web/mobile/index.vue')
  },
  // pilot
  {
    path: '/' + ERouterName.PILOT,
    name: ERouterName.PILOT,
    component: () => import('/@/pages/page-pilot/pilot-index.vue'),
  },
  {
    path: '/' + ERouterName.PILOT_HOME,
    component: () => import('/@/pages/page-pilot/pilot-home.vue')
  },
  {
    path: '/' + ERouterName.PILOT_MEDIA,
    component: () => import('/@/pages/page-pilot/pilot-media.vue')
  },
  {
    path: '/' + ERouterName.PILOT_LIVESHARE,
    component: () => import('/@/pages/page-pilot/pilot-liveshare.vue')
  },
  {
    path: '/' + ERouterName.PILOT_BIND,
    component: () => import('/@/pages/page-pilot/pilot-bind.vue')
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

// Svaka uloga osim admina sme SAMO na svoj ekran i na prijavu (30.10.2026: ranije je
// nadzorni centar smeo i u kokpit i na /m). Server ionako sam proverava ulogu (lds-auth i
// lds-notify), ovo je samo ograda u pregledaču.
//   operator (nadzorni centar) -> /monitoring, direktor -> /direktor
router.beforeEach((to, _from, next) => {
  const role = localStorage.getItem('lds_role')
  if (role && role !== 'admin') {
    const svoj = '/' + (role === 'direktor' ? ERouterName.DIREKTOR : ERouterName.MONITORING)
    if (![svoj, '/' + ERouterName.PROJECT, '/'].includes(to.path)) {
      next(svoj)
      return
    }
  }
  next()
})

export default router
